import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spinner, YStack, Paragraph } from 'tamagui';
import { supabase } from '../lib/supabase';

/**
 * Supabase returns the magic-link session in the URL hash (`#access_token=…`).
 * `detectSessionInUrl: true` (in supabase client) parses it automatically.
 * We just wait for the session to land in state, then redirect home.
 */
export function AuthCallback() {
  const navigate = useNavigate();
  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      if (data.session) {
        navigate('/', { replace: true });
      } else {
        // Fallback: small delay in case the detection is still mid-flight
        const t = setTimeout(() => navigate('/login', { replace: true }), 3000);
        return () => clearTimeout(t);
      }
    });
  }, [navigate]);
  return (
    <YStack
      minHeight="100vh"
      alignItems="center"
      justifyContent="center"
      gap="$3"
    >
      <Spinner />
      <Paragraph color="$color10">Finishing sign-in…</Paragraph>
    </YStack>
  );
}
